<template>
    <el-dialog
        title="收款确认"
        :visible.sync="paymentConfirmationDialog"
        width="800px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom-payable-dialog custom_payment_confirmation_dialog"
    >
        <div v-if="source_type == 'order' && confirmType === 'confirm'">
            <div class="page_little_title">订单信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="关联订单">
                            <div>
                                <el-link
                                    type="primary"
                                    v-text="receivableDetails.basic_info.order_no"
                                    :underline="false"
                                    @click="handleClickOrderDetail(receivableDetails.basic_info.order_no)"
                                >
                                </el-link>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户联系人">
                            <div
                                v-text="
                                    receivableDetails.basic_info.customer_contact_info &&
                                    receivableDetails.basic_info.customer_contact_info.name
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="订单总金额">
                            <div v-text="receivableDetails.basic_info.order_amount"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="销售">
                            <div
                                v-text="
                                    receivableDetails.basic_info.salesperson_info &&
                                    receivableDetails.basic_info.salesperson_info.name
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="page_little_title">回款信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="回款公司">
                            <div v-text="receivableDetails.basic_info.payment_company_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="回款日期">
                            <div v-text="receivableDetails.basic_info.payment_date"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="回款方式">
                            <div v-text="receivableDetails.basic_info.payment_method_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="本次回款金额">
                            <div v-text="receivableDetails.basic_info.payment_amount"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <div
                                class="text_bg"
                                v-if="receivableDetails.basic_info && receivableDetails.basic_info.remark"
                                v-text="receivableDetails.basic_info.remark"
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="附件">
                            <div
                                class="file_upload_wrap"
                                v-if="
                                    receivableDetails.basic_info.attachments &&
                                    receivableDetails.basic_info.attachments.length
                                "
                            >
                                <ul class="upload_file_list upload_file_list_detail">
                                    <li
                                        v-for="file in receivableDetails.basic_info.attachments"
                                        class="upload_file_item"
                                    >
                                        <div class="file_left_wrap">
                                            <img
                                                alt=""
                                                class="file_img"
                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                            />
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="page_little_title">基本信息</div>
        <el-form
            ref="paymentInfoForm"
            :rules="paymentInfoFormRules"
            :model="paymentInfoForm"
            label-position="top"
            v-loading="formLoading"
        >
            <template v-if="confirmType === 'batch_confirm'">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="应收款总金额" prop="receivable_amount_total">
                            <el-input disabled placeholder="系统自动带出" v-model="receivable_amount_total"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <template v-else>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="应收款金额" prop="unpaid_amount">
                            <el-input
                                disabled
                                placeholder="系统自动带出"
                                v-model="receivableDetails.unpaid_amount"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="收款方式" prop="payment_method">
                            <el-select placeholder="请选择" v-model="paymentInfoForm.payment_method">
                                <el-option
                                    :label="item.name"
                                    :value="item.value"
                                    v-for="item in payTypeList"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24" v-if="source_type == 'purchase_refund'">
                    <el-col :span="12">
                        <el-form-item label="退款日期" prop="confirm_time">
                            <el-date-picker
                                format="yyyy-MM-dd HH:mm:ss"
                                placeholder="请选择"
                                type="datetime"
                                v-model="paymentInfoForm.confirm_time"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="18">
                        <el-form-item label="备注" prop="remark">
                            <el-input
                                :rows="4"
                                maxlength="200"
                                placeholder="请输入备注信息"
                                type="textarea"
                                v-model="paymentInfoForm.remark"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="收款凭证" prop="voucher">
                    <ul class="voucher_list">
                        <li :key="index" class="voucher_item" v-for="(item, index) in paymentInfoForm.voucher">
                            <el-image :preview-src-list="paymentInfoForm.voucher" :src="item" alt=""> </el-image>
                            <i @click="paymentInfoForm.voucher.splice(index, 1)" class="iconfont icon-jianqu"></i>
                        </li>
                        <li @click="handleClickUploadFile" class="upload_img_wrap">
                            <i class="el-icon-plus"></i>
                        </li>
                    </ul>
                    <p class="hint">请上传银行交易凭证截图（建议大小不超过5M，支持png、jpg等格式）</p>
                </el-form-item>
            </template>
            <div v-if="confirmType === 'batch_confirm'">
                <div class="page_little_title">批量确认信息</div>
                <template v-if="source_type === 'order'">
                    <el-table :data="paymentBatchInfo" size="small" border class="custom_table">
                        <el-table-column label="回款编号" min-width="140" prop="receivable_no" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickReceivableDetail(row)"
                                    type="primary"
                                    v-text="row.receivable_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="客户公司" min-width="150" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <span>{{
                                    row.basic_info && row.basic_info.customer_info && row.basic_info.customer_info.name
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="回款公司" min-width="150" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <span>{{ row.basic_info && row.basic_info.payment_company_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单编号" min-width="140" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickOrderDetail(row.basic_info && row.basic_info.order_no)"
                                    type="primary"
                                    v-text="row.basic_info && row.basic_info.order_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="申请人" prop="user_name" min-width="140">
                            <template slot-scope="{ row }">
                                <PersonnelCard
                                    :userId="row.basic_info.salesperson_info.id"
                                    v-if="row.basic_info && row.basic_info.salesperson_info"
                                >
                                    <template slot="container">
                                        <div class="user-avatar-btn">
                                            <img
                                                :src="
                                                    row.basic_info.salesperson_info.avatar
                                                        ? row.basic_info.salesperson_info.avatar
                                                        : defaultImg
                                                "
                                                alt=""
                                            />
                                            <span>{{ row.basic_info.salesperson_info.name }}</span>
                                        </div>
                                    </template>
                                </PersonnelCard>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" label="应收款金额" prop="receivable_amount" min-width="116">
                            <template slot-scope="{ row }">
                                <span>{{ row.receivable_info.receivable_amount }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="收款方式" prop="payment_method" min-width="116">
                            <template slot="header" slot-scope="scope">
                                <div class="custom_table_header">
                                    <span class="time_txt">收款方式</span>
                                </div>
                            </template>
                            <template slot-scope="{ row }">
                                <el-select v-model="row.payment_method" placeholder="请选择" class="pay_custom_input">
                                    <el-option
                                        :label="item.name"
                                        :value="item.value"
                                        v-for="item in payTypeList"
                                    ></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="回款时间" prop="confirm_time" min-width="220">
                            <template slot="header" slot-scope="scope">
                                <div class="custom_table_header">
                                    <span class="time_txt">回款时间</span>
                                    <el-popover
                                        ref="batchTimePopover"
                                        placement="bottom"
                                        title=""
                                        width="260"
                                        trigger="click"
                                        content=""
                                    >
                                        <div class="batch_time">
                                            <el-date-picker
                                                format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="请选择"
                                                type="datetime"
                                                v-model="batchTime"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                :clearable="false"
                                                @change="handleBatchTimeChange"
                                                class="pay_custom_input"
                                            >
                                            </el-date-picker>
                                        </div>
                                        <el-link :underline="false" slot="reference" type="primary">
                                            <i class="iconfont icon-tianjia1"></i>
                                        </el-link>
                                    </el-popover>
                                </div>
                            </template>
                            <template slot-scope="{ row }">
                                <el-date-picker
                                    format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择"
                                    type="datetime"
                                    v-model="row.confirm_time"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    class="pay_custom_input"
                                >
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="备注" prop="remark" min-width="116">
                            <template slot-scope="{ row }">
                                <el-input
                                    v-model="row.remark"
                                    placeholder="请输入备注"
                                    class="pay_custom_input"
                                    maxlength="200"
                                ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="收款凭证" prop="voucher" min-width="116">
                            <template slot-scope="{ row }">
                                <div class="table_upload_outer">
                                    <ul class="voucher_list">
                                        <template v-if="row.voucher && row.voucher.length">
                                            <li class="voucher_item" :key="index" v-for="(item, index) in row.voucher">
                                                <el-image
                                                    :preview-src-list="row.voucher"
                                                    :src="item"
                                                    alt=""
                                                    class="item_img"
                                                >
                                                </el-image>
                                                <i
                                                    @click="row.voucher.splice(index, 1)"
                                                    class="iconfont icon-jianqu"
                                                ></i>
                                            </li>
                                        </template>
                                        <div @click="handleClickTableUploadFile(row)" class="table_upload_img_wrap">
                                            <i class="iconfont icon-shangchuan"></i>
                                        </div>
                                    </ul>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" fixed="right" label="操作" width="62">
                            <template slot-scope="{ row }">
                                <i class="iconfont icon-shanchu1 cursor" @click="handleClickBatchDelete(row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template v-else-if="source_type === 'purchase_refund'">
                    <el-table :data="paymentBatchInfo" size="small" border class="custom_table">
                        <el-table-column label="应收编号" min-width="140" prop="receivable_no" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickPayableDetail(row)"
                                    type="primary"
                                    v-text="row.receivable_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="供应商名称" min-width="150" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <span>{{ row.basic_info && row.basic_info.supplier_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="采购编号" min-width="140" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickRelateId(row.basic_info && row.basic_info.purchase_id)"
                                    type="primary"
                                    v-text="row.basic_info && row.basic_info.purchase_refund_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="审批编号" min-width="100" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickApprovalDetail(row.basic_info && row.basic_info.approval_id)"
                                    type="primary"
                                    v-text="row.basic_info && row.basic_info.approval_id"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="申请人" prop="user_name" min-width="140">
                            <template slot-scope="{ row }">
                                <PersonnelCard
                                    :userId="row.basic_info.uid_info.id"
                                    v-if="row.basic_info && row.basic_info.uid_info"
                                >
                                    <template slot="container">
                                        <div class="user-avatar-btn">
                                            <img
                                                :src="
                                                    row.basic_info.uid_info.avatar
                                                        ? row.basic_info.uid_info.avatar
                                                        : defaultImg
                                                "
                                                alt=""
                                            />
                                            <span>{{ row.basic_info.uid_info.name }}</span>
                                        </div>
                                    </template>
                                </PersonnelCard>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" label="应收款金额" prop="receivable_amount" min-width="116">
                            <template slot-scope="{ row }">
                                <span>{{ row.receivable_info.receivable_amount }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="收款方式" prop="payment_method" min-width="116">
                            <template slot="header" slot-scope="scope">
                                <div class="custom_table_header">
                                    <span class="time_txt">收款方式</span>
                                </div>
                            </template>
                            <template slot-scope="{ row }">
                                <el-select v-model="row.payment_method" placeholder="请选择" class="pay_custom_input">
                                    <el-option
                                        :label="item.name"
                                        :value="item.value"
                                        v-for="item in payTypeList"
                                    ></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="退款时间" prop="confirm_time" min-width="180">
                            <template slot="header" slot-scope="scope">
                                <div class="custom_table_header">
                                    <span class="time_txt">退款时间</span>
                                    <el-popover
                                        ref="batchTimePopover"
                                        placement="bottom"
                                        title=""
                                        width="260"
                                        trigger="click"
                                        content=""
                                    >
                                        <div class="batch_time">
                                            <el-date-picker
                                                format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="请选择"
                                                type="datetime"
                                                v-model="batchTime"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                :clearable="false"
                                                @change="handleBatchTimeChange"
                                                class="pay_custom_input"
                                            >
                                            </el-date-picker>
                                        </div>
                                        <el-link :underline="false" slot="reference" type="primary">
                                            <i class="iconfont icon-tianjia1"></i>
                                        </el-link>
                                    </el-popover>
                                </div>
                            </template>
                            <template slot-scope="{ row }">
                                <el-date-picker
                                    format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择"
                                    type="datetime"
                                    v-model="row.confirm_time"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :clearable="false"
                                    class="pay_custom_input"
                                >
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="备注" prop="remark" min-width="116">
                            <template slot-scope="{ row }">
                                <el-input
                                    v-model="row.remark"
                                    placeholder="请输入备注"
                                    class="pay_custom_input"
                                    maxlength="200"
                                ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="收款凭证" prop="voucher" min-width="116">
                            <template slot-scope="{ row }">
                                <div class="table_upload_outer">
                                    <ul class="voucher_list">
                                        <template v-if="row.voucher && row.voucher.length">
                                            <li class="voucher_item" :key="index" v-for="(item, index) in row.voucher">
                                                <el-image
                                                    :preview-src-list="row.voucher"
                                                    :src="item"
                                                    alt=""
                                                    class="item_img"
                                                >
                                                </el-image>
                                                <i
                                                    @click="row.voucher.splice(index, 1)"
                                                    class="iconfont icon-jianqu"
                                                ></i>
                                            </li>
                                        </template>
                                        <div @click="handleClickTableUploadFile(row)" class="table_upload_img_wrap">
                                            <i class="iconfont icon-shangchuan"></i>
                                        </div>
                                    </ul>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" fixed="right" label="操作" width="62">
                            <template slot-scope="{ row }">
                                <i class="iconfont icon-shanchu1 cursor" @click="handleClickBatchDelete(row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <div class="total_payment mb_24">
                    <span
                        >应收款总金额：{{
                            paymentBatchInfo.reduce(
                                (total, item) => total + Number(item.receivable_info.receivable_amount),
                                0
                            )
                        }}</span
                    >
                </div>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">提交</el-button>
        </span>
        <!-- <ReceivableDetails
            v-if="receivableDetailsVisible"
            :receivableDetailsVisible.sync="receivableDetailsVisible"
            :receivable_no="detail_receivable_no"
        /> -->
        <PurchaseDetail
            :purchaseDetailVisible.sync="purchaseDetailVisible"
            v-if="purchaseDetailVisible"
            :purchaseId="purchaseId"
        />
        <el-image
            :preview-src-list="previewImgList"
            :src="previewImgSrc"
            ref="preview_img"
            style="display: none"
        ></el-image>
    </el-dialog>
</template>
<script>
import { ReceivableBatchConfirm, ReceivableDetail, ReceivableDetailBatch } from "@/api";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
// import ReceivableDetails from "./receivable_details.vue";
import PurchaseDetail from "../../../Purchase/component/purchase_detail.vue"; //采购详情
import { getOSSData, uploadImg } from "@/utils/uploadOss";
import { formatDate } from "@/utils";
export default {
    name: "PaymentConfirmation",
    components: { PersonnelCard, PurchaseDetail },
    props: {
        paymentConfirmationDialog: {
            type: Boolean,
            default: false,
        },
        receivable_no: "", // 应收单号
        confirmType: {
            type: String,
            default: "",
        }, // confirm:单个确认，batch_confirm：批量确认
        source_type: {
            type: String,
            default: "",
        }, // 回款类型：采购=purchase_refund，订单：order
    },
    data() {
        return {
            formLoading: true,
            defaultImg: require("@/assets/images/default.jpg"),
            receivableDetails: {
                source_type: "",
                basic_info: {}, // 订单信息
                receivable_info: {}, // 财务信息
                other_info: {}, // 驳回信息
                other_info: {}, // 作废信息
            },
            paymentInfoForm: {
                payment_method: "",
                confirm_time: "",
                remark: "",
                voucher: [],
                paylog_bill: [],
                pay_amount: "",
                receivable_amount_total: 0,
            },
            paymentInfoFormRules: {
                pay_amount: [
                    {
                        required: true,
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (!value) callback(new Error("请输入支付金额"));
                            if (Number(value) > Number(this.receivableDetails.unpaid_amount))
                                return callback(new Error("支付金额不能大于未付金额"));
                            callback();
                        },
                    },
                ],
                confirm_time: [{ required: true, message: "请选择回款日期", trigger: "change" }],
                payment_method: [{ required: true, message: "请选择收款方式", trigger: "change" }],
            },
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],
            // 批量设置的时间
            batchTime: "",
            paymentBatchInfo: [],
            btnDisabled: false,

            // 详情
            detail_receivable_no: "",
            receivableDetailsVisible: false,

            purchaseId: null,
            purchaseDetailVisible: false, //采购详情

            previewImgList: [],
            previewImgSrc: "",
        };
    },
    computed: {
        receivable_amount_total() {
            return this.paymentBatchInfo.reduce(
                (total, item) => total + Number(item.receivable_info.receivable_amount),
                0
            );
        },
    },
    created() {
        this.formLoading = false;
        if (this.receivable_no) {
            if (this.confirmType === "confirm") {
                // 单个确认
                this.getReceivableDetail();
            } else {
                // 批量确认
                this.getReceivableDetailBatch();
            }
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:paymentConfirmationDialog", false);
        },
        // 应收详情-单个
        getReceivableDetail() {
            ReceivableDetail({ receivable_no: this.receivable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.receivableDetails = data;
                    this.receivableDetails.unpaid_amount =
                        this.receivableDetails.receivable_info &&
                        this.receivableDetails.receivable_info.receivable_amount;
                    this.paymentInfoForm.confirm_time =
                        this.receivableDetails.basic_info && this.receivableDetails.basic_info.payment_date
                            ? formatDate(this.receivableDetails.basic_info.payment_date, "date-second-time")
                            : "";
                    this.paymentInfoForm.payment_method = data.basic_info && data.basic_info.payment_method;
                }
            });
        },
        // 应收详情-批量
        getReceivableDetailBatch() {
            ReceivableDetailBatch({ receivable_nos: this.receivable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.paymentBatchInfo = data.map((item) => {
                        return {
                            ...item,
                            payment_method: item.basic_info.payment_method,
                            confirm_time: item.basic_info.payment_date ? formatDate(item.basic_info.payment_date, "date-second-time") : "",
                        };
                    });
                    // this.paymentInfoForm.receivable_amount_total = this.paymentBatchInfo.reduce(
                    //     (total, item) => total + Number(item.receivable_info.receivable_amount),
                    //     0
                    // );
                }
            });
        },
        // 批量-删除
        handleClickBatchDelete(row) {
            const index = this.paymentBatchInfo.findIndex((item) => item.receivable_no === row.receivable_no);
            this.paymentBatchInfo.splice(index, 1);
        },
        // 批量设置时间
        handleBatchTimeChange() {
            this.$refs.batchTimePopover.doClose();
            this.paymentBatchInfo.forEach((item) => {
                this.$set(item, "confirm_time", this.batchTime);
            });
        },
        //格式化输入的支付金额
        handlePayAmountBlur(formData, unpaid_amount) {
            formData["pay_amount"] = formData["pay_amount"].replace(/[^\d\.]/g, "");
            if (Number(formData["pay_amount"]) > Number(unpaid_amount)) {
                formData["pay_amount"] = unpaid_amount;
            }
            if (formData["pay_amount"]) {
                let amount = Math.abs(parseFloat(formData["pay_amount"]));
                const some = unpaid_amount.toString().split(".")[1].length;
                const parts = amount.toFixed(some).split(".");
                const integerPart = parts[0];
                const decimalPart = some > 0 ? (parts[1] ? parts[1] : "0".repeat(some)) : "";
                // 拼接成完整的金额格式
                formData["pay_amount"] = some > 0 ? `${integerPart}.${decimalPart}` : integerPart;
            }
        },
        handleClickUploadFile() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024))
                    return that.$message.error("图片大小不允许超过5m");
                // if (that.paymentInfoForm.voucher.length + files.length > 5)
                //     return that.$message.error("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            that.paymentInfoForm.voucher.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        // 表格上传的凭证
        handleClickTableUploadFile(row) {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            // input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024))
                    return that.$message.error("图片大小不允许超过5m");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            let fileList = row.voucher || [];
                            fileList.push(res.file_path);
                            // console.log(fileList);
                            that.$set(row, "voucher", fileList);
                            // console.log(row);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        handleDialogConfirm() {
            this.$refs.paymentInfoForm.validate((valid) => {
                if (valid) {
                    let receivables = [];

                    if (this.confirmType === "confirm") {
                        // 单个确认
                        receivables.push({
                            receivable_no: this.receivable_no,
                            payment_method: this.paymentInfoForm.payment_method,
                            confirm_time: this.paymentInfoForm.confirm_time,
                            remark: this.paymentInfoForm.remark,
                            voucher: this.paymentInfoForm.voucher,
                        });
                    } else {
                        // 批量确认
                        receivables = this.paymentBatchInfo.map((item) => ({
                            receivable_no: item.receivable_no,
                            payment_method: item.payment_method,
                            confirm_time: item.confirm_time,
                            remark: item.remark,
                            voucher: item.voucher,
                        }));
                    }
                    const is_valid = receivables.every((item) => item.confirm_time && item.payment_method);
                    if (!is_valid) return this.$message.error("请检查数据是否填写完整");
                    if (this.confirmType === "batch_confirm" && !receivables.length) return;
                    this.btnDisabled = true;
                    this.formLoading = true;
                    ReceivableBatchConfirm({ receivables: receivables })
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.$emit("confirmSuccess");
                                        this.handleDialogClose();
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.formLoading = false;
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        });
                }
            });
        },
        // 回款编号详情
        handleClickReceivableDetail(row) {
            this.$emit("handleClickLookPaymentDetail", row);
            // this.detail_receivable_no = row.receivable_no;
            // this.receivableDetailsVisible = true;
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
        //查看订单详情
        handleClickOrderDetail(order_no) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_no,
                    name: order_no,
                    query_type: "order_no",
                },
            });
        },
    },
};
</script>
<style lang="scss">
.mb_24 {
    margin-bottom: 24px;
}
.custom_payment_confirmation_dialog {
    .el-dialog__body {
        max-height: 690px;
        overflow-y: auto;
    }
    .page_little_title {
        line-height: 22px;
        color: #333333;
        font-weight: 700;
        padding-left: 8px;
        position: relative;
        margin-bottom: 16px;

        &::before {
            width: 3px;
            height: 22px;
            border-radius: 2px;
            background: #409eff;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .voucher_list {
        display: flex;
        gap: 8px;

        .upload_img_wrap {
            width: 48px;
            height: 48px;
            background: #edf0f4;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-icon-plus {
                color: #666666;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .voucher_item {
            width: 48px;
            height: 48px;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }

            .icon-jianqu {
                position: absolute;
                right: -8px;
                top: -8px;
                cursor: pointer;
                font-size: 16px;
                color: rgba(255, 77, 79, 1);
                line-height: 16px;
            }
        }
    }
    .el-form {
        .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }
        .text_bg {
            padding: 8px 12px;
            line-height: 22px;
            border-radius: 6px;
            background: rgba(237, 240, 244, 1);
        }
        .el-link {
            display: inline;
        }
    }
    .total_payment {
        width: 100%;
        padding: 8px 12px;
        border-radius: 6px 6px, 0px, 0px;
        background: rgba(237, 240, 244, 1);
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-right: 24px;
        }
    }
    .el-table {
        .custom_table_header {
            display: flex;
            justify-content: space-between;
            .time_txt {
                position: relative;
                &::before {
                    content: "*";
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    color: rgba(228, 65, 68, 1);
                }
            }
        }
        .el-link {
            font-weight: 400;
            color: rgba(41, 144, 255, 1);
        }
        .el-select,
        .el-input__inner {
            border: 0;
        }
        .table_upload_outer {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            padding: 2px 0;
            .voucher_list {
                flex-wrap: wrap;
            }
            .voucher_item {
                width: 32px;
                height: 32px;
                line-height: 32px;
                .icon-jianqu {
                    top: -4px !important;
                    right: -4px !important;
                }
            }
        }
        .table_upload_img_wrap {
            display: inline-block;
            vertical-align: middle;
            width: 32px;
            height: 32px;
            background: #edf0f4;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 32px;
            border-radius: 4px;
            .icon-shangchuan {
                color: #666666;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
            }
        }
        .item_img {
            width: 32px;
            height: 32px;
            border-radius: 4px;
            object-fit: contain;
            vertical-align: middle;
        }
    }
}
.el-table {
    .pay_custom_input {
        &.el-date-editor {
            .el-input__inner {
                padding: 0 12px 0 30px !important;
            }
            .el-input__prefix {
                left: 0;
            }
        }
        .el-input__inner {
            padding: 0;
            border: 0;
            background: transparent;
            // text-align: right;
        }
    }
}
</style>
